import React from 'react';
import { Row, Container, Col } from 'react-bootstrap';
import { getFreeSlots, getDate, getDayShortName } from './CalendarUtil';
import TimeSlot from './BookingTimeSlot';

function CalendarDay(props) {

    function onSelected(slot) {
        props.onSelect(slot);
    }

    function getSlots() {
        let openSlots = props.customerData.slots;
        let exceptions = props.customerData.exceptions;
        const freeSlots = getFreeSlots(
            props.date,
            props.bookings,
            openSlots,
            exceptions,
            props.category,
            props.customerData.settings
        );
        let slotElements = [];
        if (freeSlots.length === 0) {
            slotElements = <TimeSlot empty={true}></TimeSlot>
        } else {
            slotElements = freeSlots.map((fs) => (
                <TimeSlot key={fs.start} empty={false} onSelected={onSelected} slot={fs} />
            ));
        }
        return (
            <Col>
                {slotElements}
            </Col>
        );
    }

    return (
        <Container className="calendar-day-container">
            <Row className="justify-content-md-center">
                <Col className="text-center">
                    <h5 className="text-headertext">{getDate(props.date)}</h5>
                    <h6 className="text-subtext">{getDayShortName(props.date)}</h6>
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                {getSlots()}
            </Row>
        </Container>
    );

}

export default CalendarDay;